export namespace DYNAMIC_PROPERTY {
  export enum KEY {
    NoMatched = 0,

    PageNumber,
    TotalPageNumber,

    TenantName,

    InspectionReportTitle,
    InspectionReportRevision,
    InspectionReportOwner,

    InspectionInspectionDate,
    InspectionSubjectSerialNo,
    InspectionSubjectModelName,
    InspectionSubjectOwner,
    InspectionSubjectCountry,
    InspectionSubjectState,
    InspectionSubjectDistrict,
    InspectionSubjectSite,
    InspectionSubjectProject,

    InspectionMarkLabel,
    InspectionLocationIdentifierComment,

    InspectionInspectorsName,
    InspectionInspectorsInitials,
    InspectionInspectorsEmail,
    InspectionInspectorsTelephoneNumber,

    InspectionSummaryLocationIdentifier,
    InspectionSummaryLocationLowermostIdentifier,
    InspectionSummaryLocationName,
    InspectionSummaryLocationLowermostName,
    InspectionSummaryInspectionFor,
    InspectionSummaryMark,
    InspectionSummaryClass,
    InspectionSummaryTitle,
    InspectionSummaryComment,

    InspectionPicturesLocationIdentifier,
    InspectionPicturesLocationLowermostIdentifier,
    InspectionPicturesLocationName,
    InspectionPicturesLocationLowermostName,
    InspectionPicturesLocationUppermostName,
    InspectionPicturesInspectionFor,
    InspectionPicturesMark,
    InspectionPicturesClass,
    InspectionPicturesTitle,
    InspectionPicturesComment,
    InspectionPicturesImage,

    MeasurementResult,
    MeasurementResultWithObjectDistance,

    SystemNow,
    DataPlateLocationName,
    Border
  }

  export const PATTERNS = {
    [KEY.PageNumber]: "pageNumber",
    [KEY.TotalPageNumber]: "totalPageNumber",

    [KEY.TenantName]: "tenant\\.name",

    [KEY.InspectionReportTitle]: "inspectionReport\\.title",
    [KEY.InspectionReportRevision]: "inspectionReport\\.revision",
    [KEY.InspectionReportOwner]: "inspectionReport\\.owner",

    [KEY.InspectionInspectionDate]: "inspection\\[(?<index>.*)\\]\\.inspectionDate",
    [KEY.InspectionSubjectSerialNo]: "inspection\\[(?<index>.*)\\]\\.subject\\.serialNo",
    [KEY.InspectionSubjectModelName]: "inspectionReport\\.subjectModel\\.name",

    [KEY.InspectionSubjectOwner]: "inspection\\[(?<index>.*)\\]\\.subject\\.owner",
    [KEY.InspectionSubjectCountry]: "inspection\\[(?<index>.*)\\]\\.subject\\.country",
    [KEY.InspectionSubjectState]: "inspection\\[(?<index>.*)\\]\\.subject\\.state",
    [KEY.InspectionSubjectDistrict]: "inspection\\[(?<index>.*)\\]\\.subject\\.district",
    [KEY.InspectionSubjectSite]: "inspection\\[(?<index>.*)\\]\\.subject\\.site",
    [KEY.InspectionSubjectProject]: "inspection\\[(?<index>.*)\\]\\.subject\\.project",

    [KEY.InspectionMarkLabel]: "inspection\\.mark\\[(?<index>.*)\\]\\.label",
    [KEY.InspectionLocationIdentifierComment]: "inspection\\.identifier\\.comment",

    [KEY.InspectionInspectorsName]: "inspection\\[(?<index>.*)\\]\\.inspectors\\.name",
    [KEY.InspectionInspectorsInitials]: "inspection\\[(?<index>.*)\\]\\.inspectors\\.initials",
    [KEY.InspectionInspectorsEmail]: "inspection\\[(?<index>.*)\\]\\.inspectors\\.email",
    [KEY.InspectionInspectorsTelephoneNumber]: "inspection\\[(?<index>.*)\\]\\.inspectors\\.telephoneNumber",

    [KEY.InspectionSummaryLocationIdentifier]: "inspectionSummary\\.location\\[(?<index>.*)\\]\\.identifier",
    [KEY.InspectionSummaryLocationLowermostIdentifier]: "inspectionSummary\\.location\\.identifier",
    [KEY.InspectionSummaryLocationName]: "inspectionSummary\\.location\\[(?<index>.*)\\]\\.name",
    [KEY.InspectionSummaryLocationLowermostName]: "inspectionSummary\\.location\\.name",
    [KEY.InspectionSummaryInspectionFor]: "inspectionSummary\\.inspectionFor",
    [KEY.InspectionSummaryMark]: "inspectionSummary\\.mark\\[(?<index>.*)\\]",
    [KEY.InspectionSummaryClass]: "inspectionSummary\\.class",
    [KEY.InspectionSummaryTitle]: "inspectionSummary\\.title",
    [KEY.InspectionSummaryComment]: "inspectionSummary\\.comment",

    [KEY.InspectionPicturesLocationIdentifier]: "inspectionPictures\\.location\\[(?<index>.*)\\]\\.identifier",
    [KEY.InspectionPicturesLocationLowermostIdentifier]: "inspectionPictures\\.location\\.identifier",
    [KEY.InspectionPicturesLocationName]: "inspectionPictures\\.location\\[(?<index>.*)\\]\\.name",
    [KEY.InspectionPicturesLocationLowermostName]: "inspectionPictures\\.location\\.name",
    [KEY.InspectionPicturesLocationUppermostName]: "inspectionPictures\\.upperLocation\\.name",
    [KEY.InspectionPicturesInspectionFor]: "inspectionPictures\\.inspectionFor",
    [KEY.InspectionPicturesMark]: "inspectionPictures\\.mark",
    [KEY.InspectionPicturesClass]: "inspectionPictures\\.class",
    [KEY.InspectionPicturesTitle]: "inspectionPictures\\.title",
    [KEY.InspectionPicturesComment]: "inspectionPictures\\.comment",
    [KEY.InspectionPicturesImage]: "inspectionPictures\\.image",

    [KEY.MeasurementResultWithObjectDistance]: "measurementResultWithObjectDistance",
    [KEY.MeasurementResult]: "measurementResult",

    [KEY.SystemNow]: "system\\.now",
    [KEY.DataPlateLocationName]: "dataPlate\\.location\\.name",
    [KEY.Border]: "system\\.border"
  };
}

export class DynamicProperty {
  index: number;

  key: DYNAMIC_PROPERTY.KEY;

  text: string;

  constructor(dynamicId: string) {
    this.index = -1;
    this.key = DYNAMIC_PROPERTY.KEY.NoMatched;
    this.text = "";

    if (dynamicId) {
      this.text = dynamicId;
      this.index = 1;
    }

    const patterns = Object.entries(DYNAMIC_PROPERTY.PATTERNS).map((arr) => {
      return {
        key: arr[0],
        value: arr[1]
      };
    });
    patterns.forEach((pattern) => {
      const reg = new RegExp(pattern.value);
      const matched = this.text.match(reg);
      if (matched) {
        if (pattern.value.includes("<index>")) {
          const parsed = parseInt(matched.groups["index"], 10);
          if (!isNaN(parsed)) {
            this.index = parsed;
          }
          this.key = Number(pattern.key);
          return true;
        } else if (matched[0] === matched.input) {
          this.key = Number(pattern.key);
          return true;
        }
      }
      return false;
    });
  }
}
